import React from "react";
import Header from "src/Component/content-component/Header";
import ParaData from "src/Component/content-component/ParaData";
import ContentContainer from "src/Component/grid-component/ContentContainer";
import ImageContainer from "src/Component/grid-component/ImageContainer";
import MainContainer from "src/Component/grid-component/MainContainer";
const imageBaseUrl = process.env.REACT_APP_IMAGE_URL
const img = imageBaseUrl + 'immersion/immersionwhat.png'
const WhatIsImmersion = () => {
  return (
    <>
      <MainContainer
        com2={
          <ContentContainer
            Header={<Header content={"What is Immersion"} color="#00999E" />}
            Content={
              <ParaData
                color={"#525560"}
                fontSize={"16px"}
                content={
                  "A Global Immersion Program (GIP) is a transformative international learning experience that connects students with diverse cultures, global industries, and top educational institutions worldwide. Immersion drives total engagement, where learning, experience, and transformation break boundaries, fostering deeper personal growth and real-world application. These career-enhancing programs include short-term study tours, student exchange programs, industry visits, international internships, and collaborative research projects, offering hands-on exposure to global business, innovation, and cross-cultural engagement. "
                }
              />
            }
          />
        }
        com1={<ImageContainer img={img} />}
      />
    </>
  );
};

export default WhatIsImmersion;
